import { render, staticRenderFns } from "./FormSuppliers.vue?vue&type=template&id=93c8d96c&"
import script from "./FormSuppliers.vue?vue&type=script&lang=js&"
export * from "./FormSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./FormSuppliers.vue?vue&type=style&index=0&id=93c8d96c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports